import React, { useContext, useEffect } from 'react';
import {
	IOfferContext,
	ITypeVignetteOrderingProcessFields,
	Locales,
	OfferContext,
	VignetteContext,
	countryUrlMap,
	fetchInitialVignetteData,
	getSupplierIdByCountry,
	getUrlBasePath,
	getVignetteOrderingProcessCollection,
	resetStorageAndContext,
	setRouteLangParam,
} from '@adac-mp/shared';
import { ContentLoader, getDrawerHelperData, withLocalization } from '@adac-mp/components';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ProductSelection } from '../../components/vignette/selection';
import { CategorySelection } from '../../components/vignette/categorySelection';
import Configuration from '../../components/configuration';
import { TimeSelection } from '../../components/vignette/timeSelection';
import { PlatesSelection } from '../../components/vignette/platesSelection';

const VignetteConfigurationSvnComponent = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const supplierId = getSupplierIdByCountry(location);
	const { updateVignetteOffers, updateAllCountries, updateAllOffers } = useContext<IOfferContext>(OfferContext);
	const { lang } = useParams();
	const { contentfulLabels, updateContentfulLabels, updateCart, deleteSelectedProducts } =
		useContext(VignetteContext);
	const currentLabels = contentfulLabels as ITypeVignetteOrderingProcessFields;

	const { error, data, loading } = useQuery(getVignetteOrderingProcessCollection, {
		variables: { lang: lang || 'de', slug: 'vignette-svn' },
	});

	useEffect(() => {
		if (!error) {
			updateContentfulLabels(data?.vignetteOrderingProcessCollection.items[0]);
		}
	}, [data]);

	useEffect(() => {
		resetStorageAndContext(supplierId, deleteSelectedProducts, updateCart);

		fetchInitialVignetteData(getSupplierIdByCountry(location), {
			navigate,
			lang: lang as Locales,
			updateVignetteOffers,
			updateAllOffers,
			updateAllCountries,
		});
	}, [lang]);

	const onFinished = () => {
		navigate(getUrlBasePath(`/${countryUrlMap[supplierId]}/product-done${setRouteLangParam(lang)}`));
	};

	// Props added dynamically in Configuration component
	const componentList = [
		{
			title: 'Fahrzeugauswahl',
			component: <CategorySelection key="step0" />,
		},
		{
			title: 'Produktauswahl',
			component: (
				<ProductSelection
					key="step1"
					supplierId={supplierId}
					helpContent={getDrawerHelperData('productSelectionSlovenia', currentLabels?.helpDrawers)}
				/>
			),
		},
		{
			title: 'Gültigkeitszeitraum',
			component: (
				<TimeSelection
					key="step2"
					helpContent={getDrawerHelperData('sloveniaVignetteInfo', currentLabels?.helpDrawers)}
				/>
			),
		},
		{
			title: 'Kennzeicheneingabe',
			component: <PlatesSelection key="step3" hasSpecialPlates />,
		},
	];

	return (
		<>
			{loading ? (
				<ContentLoader isLoading hasPortal={false} />
			) : (
				<Configuration
					withStepReset
					supplierHasMultipleProducts
					componentList={componentList}
					supplierId={supplierId}
					onFinished={onFinished}
				/>
			)}
		</>
	);
};

export const VignetteConfigurationSvn = withLocalization(VignetteConfigurationSvnComponent);
